export enum CheckoutRedirectOrderStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
}
